export default __webpack_public_path__ + "static/media/waving-man.ce3034e6.svg";